import React from 'react';

import { Typography, Button } from '@mui/material';

type Props = {
  isDisabled: boolean;
  onClick: () => void;
};

const ClearButton: React.FC<Props> = ({ isDisabled, onClick }) => {
  return (
    <Button
      disabled={isDisabled}
      onClick={onClick}
      variant='outlined'
      color='darkBlue'
      sx={{
        borderRadius: '40px',
        height: '36px',
        padding: '0 8px',
      }}
    >
      <Typography fontSize={14}>Clear</Typography>
    </Button>
  );
};

export default ClearButton;
